'use strict';

intellidealerAppCoreModule.factory('customerPartCrossReferencesResource', function ($resource, appConfigurationService) {
  return {
    myDealerCustomerPartCrossReferencesByPart: $resource(appConfigurationService.basePath + '/rest/customerpartcrossreferences/myDealerCustomerPartCrossReferencesByPart/')
  }
});
